<template>
  <div>
    <LaboratoryCategoryFilter
      v-if="$can('filter', 'laboratory-categorys')"
      :loading="loading"
      @searchFilter="searchFilter"
      @filterPage="filterPage"
    />
    <b-card>
      <TitleTable
        titleTable="Laboratory Categories"
        iconTable="fas fa-disease"
      />
      <div class="m-1">
        <LaboratoryCategoryEdit
          v-if="isEditLaboratoryCategorySidebarActive"
          :is-edit-laboratory-category-sidebar-active.sync="
            isEditLaboratoryCategorySidebarActive
          "
          :itemEdit="itemEdit"
          @editLaboratoryCategorySuccess="editLaboratoryCategorySuccess"
        />
        <LaboratoryCategoryAdd
          :is-add-new-laboratory-category-sidebar-active.sync="
            isAddNewLaboratoryCategorySidebarActive
          "
          @createLaboratoryCategory="createLaboratoryCategory"
        />
        <!-- Table Top -->
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <treeselect
              v-model="perPage"
              :options="perPageOptions"
              :clearable="true"
              class="w-25"
            />
          </b-col>
          <!-- {{ $t("Search") }} -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <GoBack class="mr-2" />
              <b-button
                v-if="$can('store', 'laboratory-categorys')"
                variant="primary"
                @click="isAddNewLaboratoryCategorySidebarActive = true"
                :disabled="loading"
              >
                <span v-if="!loading" class="text-nowrap"
                  >{{ $t("Add") }} LaboratoryCategory</span
                >
                <span v-else>
                  <SpinnerLoading />
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        :items="items"
        :fields="fields"
        hover
        bordered
        responsive
        primary-key="id"
        class="position-relative min-height-table"
        show-empty
        empty-text="No matching records found"
      >
        <template #cell(laboratories)="data">
          {{
            data.item.laboratories.length > 0
              ? data.item.laboratories[0].name
              : "-"
          }}, ...
        </template>
        <template #cell(status)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{
              data.item.status ? $t("Active") : $t("Inactive")
            }}</span>
          </div>
        </template>
        <template #cell(actions)="data">
          <b-button
            v-if="$can('update', 'laboratory-categorys')"
            variant="outline-primary"
            class="btn-icon btn-circle border-0"
            v-b-tooltip.hover.top="'Edit'"
            @click="editLaboratoryCategory(data.item)"
          >
            <i class="fas fa-pen icon-nm"></i>
          </b-button>

          <b-button
            v-if="$can('destroy', 'laboratory-categorys')"
            variant="outline-danger"
            class="btn-icon btn-circle border-0"
            v-b-tooltip.hover.top="'Delete'"
            @click="deleteLaboratoryCategory(data.item)"
          >
            <i class="fas fa-trash-alt icon-nm"></i>
          </b-button>
        </template>
      </b-table>
      <PaginationTable
        :dataMeta="dataMeta"
        :totalUsers="totalUsers"
        :perPage="perPage"
        :currentPage="currentPage"
        @page-changed="pageChanged"
      />
    </b-card>
    <ToastNotification ref="toast" />
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BBadge,
  BAvatar,
  BButton,
  VBTooltip,
} from "bootstrap-vue";
import axiosAC from "@/core/services/api/admin/consults/laboratoryCategories";

import ToastNotification from "@/components/ToastNotification";
import SpinnerLoading from "@/components/SpinnerLoading";
import PaginationTable from "@/components/PaginationTable";
import TitleTable from "@/components/TitleTable.vue";
import GoBack from "@/components/ButtonBack.vue";
import Swal from "sweetalert2";

import LaboratoryCategoryEdit from "./LaboratoryCategoryEdit.vue";
import LaboratoryCategoryAdd from "./LaboratoryCategoryAdd.vue";
import LaboratoryCategoryFilter from "./LaboratoryCategoryFilter.vue";
import { ref } from "@vue/composition-api";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BBadge,
    BAvatar,
    BButton,
    LaboratoryCategoryEdit,
    LaboratoryCategoryAdd,
    LaboratoryCategoryFilter,
    ToastNotification,
    SpinnerLoading,
    PaginationTable,
    TitleTable,
    GoBack,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      fields: [
        // A virtual column that doesn't exist in items
        "id",
        // A column that needs custom formatting
        { key: "name", label: "Name", sortable: true },
        { key: "laboratories", label: "laboratories", sortable: true },
        { key: "price", label: "Price", sortable: true },
        { key: "status", label: "Status" },
        // A virtual column made up from two fields
        { key: "actions", label: "Actions" },
      ],
      items: null,
      loading: false,
      isEditLaboratoryCategorySidebarActive: false,
      isAddNewLaboratoryCategorySidebarActive: false,
      itemEdit: null,
      dataMeta: { from: 1, to: 1, of: 1 },
      totalUsers: 0,
      perPage: 10,
      currentPage: {
        page: 1,
      },
      perPageOptions: [10, 25, 50, 100].map((i) => ({
        id: i,
        label: `Show ${i} Entries`,
      })),
      filtro: false,
      laboratoryCategoryFilter: null,
    };
  },
  mounted() {
    this.getLaboratoryCategory();
  },
  watch: {
    perPage(newVal) {
      if (!this.filtro) {
        this.getLaboratoryCategory();
      } else {
        this.searchFilter(this.laboratoryCategoryFilter);
      }
    },
  },
  methods: {
    getLaboratoryCategory() {
      axiosAC
        .categoryLabList(this.perPage)
        .then(({ data, current_page, total, per_page, ...res }) => {
          this.items = data;
          this.totalUsers = total;
          this.dataMeta.of = total;
          this.dataMeta.from = res.from;
          this.dataMeta.to = res.to;
          this.currentPage.page = current_page;
        });
    },
    editLaboratoryCategory(item) {
      this.isEditLaboratoryCategorySidebarActive = true;
      this.itemEdit = ref(JSON.parse(JSON.stringify(item)));
    },
    editLaboratoryCategorySuccess(value) {
      if (value) {
        this.$refs.toast.success(
          "Type LaboratoryCategory updated successfully"
        );
      } else {
        this.$refs.toast.error("Error updating type laboratory-category");
      }
      this.isEditLaboratoryCategorySidebarActive = false;
      this.pageChanged(this.currentPage.page);
    },
    createLaboratoryCategory({ status }) {
      if (status) {
        this.$refs.toast.success("LaboratoryCategory type added successfully");
      } else {
        this.$refs.toast.danger("LaboratoryCategory type not added");
      }
      this.isAddNewLaboratoryCategorySidebarActive = false;
      this.pageChanged(this.currentPage.page);
    },
    deleteLaboratoryCategory(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this",
        icon: "error",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axiosAC.categoryLabDelete(item.id).then((response) => {
            this.$refs.toast.success(
              "LaboratoryCategory type has been deleted successfully"
            );
            this.pageChanged(this.currentPage.page);
          });
        }
      });
    },
    pageChanged(page) {
      if (!this.filtro) {
        axiosAC
          .categoryLabPagination(this.perPage, page)
          .then(({ data, total, current_page, ...res }) => {
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          });
      } else {
        axiosAC
          .categoryLabFilterPagination(
            this.perPage,
            page,
            this.laboratoryCategoryFilter
          )
          .then(({ data, total, current_page, ...res }) => {
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          });
      }
    },
    searchFilter(value) {
      if (this.filtro) {
        this.loading = true;
        this.laboratoryCategoryFilter = value;
        axiosAC
          .categoryLabFilter(this.perPage, value)
          .then(({ registro: {data, total, current_page, ...res }}) => {
            this.loading = false;
            this.items = data;
            this.totalUsers = total;
            this.dataMeta.of = total;
            this.dataMeta.from = res.from;
            this.dataMeta.to = res.to;
            this.currentPage.page = current_page;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.getLaboratoryCategory();
      }
    },
    filterPage(value) {
      this.filtro = value;
    },
  },
};
</script>

<style></style>
